import { isImageDocument, isVideoDocument } from '../../components/File/FileUtils.js'

export const reportFiles = {
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    hideModePanel: {
      type: Boolean,
      default: false
    },
    collapsedAndNoEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      initialized: false,
      mode: 'view', // view, edit
      modes: [
        { key: 'view', name: 'Просмотр' },
        { key: 'edit', name: 'Редактирование' }
      ],

      FILES_PROPERTY: null, // @abstract
      excludeCategoriesKeys: [],
      // filesGroupsContainer: null, // не реактивное
      categoriesCollapsePanel: [],
      // categoriesMap: {}, // не реактивное
      categories: []
    }
  },
  computed: {
    roleEmployee: function () {
      return !!this.reportRoles.roleEmployee
    },
    readonly: function () {
      return !(this.report.actionsAccess && this.report.actionsAccess.editData) || !!this.collapsedAndNoEdit
    },
    editModeActive: function () {
      if (this.mode !== 'edit') {
        return false
      }
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].selectedFiles.length) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    mode: function () {
      if (this.filesGroupsContainer) {
        this.filesGroupsContainer.clearSelection()
      }
    }
  },
  methods: {
    onRemarkChanged: function () {
      this.$emit('remark-changed')
    },
    onRemoveFile: function ({ file, filesGroup }) {
      filesGroup.removeFile(file).then(() => {
        if (file.remarks) {
          const activeRemarks = file.remarks.filter(r => r.active)
          if (activeRemarks && activeRemarks.length) {
            activeRemarks.forEach(remark => {
              const reportImagesRemark = this.report.imagesRemarks.find(r => r.code === remark.code && r.comment === remark.comment)
              if (reportImagesRemark != null) {
                reportImagesRemark.documentsIds = reportImagesRemark.documentsIds.filter(docId => docId !== file.document.id)
                if (reportImagesRemark.documentsIds.length === 0) {
                  reportImagesRemark.active = false
                }
                this.onRemarkChanged()
              }
            })
          }
        }
      })
    },
    onRemoveSelectedFiles: function () {
      this.$d_ask({
        callback: () => {
          this.filesGroupsContainer.removeSelectedFiles({
            target: this
          })
        },
        header: 'Удалить выбранные файлы?'
      })
    },
    pushFiles: function (documents) {
      let allFilesNumber = 0

      const checkContentType = (category, document) => {
        if (category.contentType === 'image' && isImageDocument(document)) {
          return true
        } else if (category.contentType === 'video' && isVideoDocument(document)) {
          return true
        } else if (!category.contentType && !isImageDocument(document)) {
          return true
        }
        return false
      }

      documents.forEach(document => {
        let category = this.categoriesMap[document.category]

        if (category && checkContentType(category, document)) {
          category.pushFile(document)
          allFilesNumber++
        } else if (!document._isWorkDocument && !this.excludeCategoriesKeys.includes(document.category)) {
          category = this.categoriesMap.other
          if (category && checkContentType(category, document)) {
            category.pushFile(document)
            allFilesNumber++
          }
        }
      })
      return allFilesNumber
    }
  }
}
